import React, { memo } from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box, Typography, capitalize } from 'transfix-ui/core'
import { IHighwayContact } from 'types/graphqlTypes'
import { brandColors } from 'transfix-ui'
import { CollapsibleSection } from '../../CollapsibleSection'
import { ValueField } from '../../ValueField'
import { useContactInformationQuery } from './graphql/ContactInformationContactList'
import { removeDuplicateDispatchers } from './utils'

interface IContactInformationContactsListProps {
  carrierId: string
}

export const ContactInformationContactsList = memo<IContactInformationContactsListProps>(
  ({ carrierId }) => {
    const { data, error, loading } = useContactInformationQuery({
      variables: { carrierApplicationId: carrierId },
    })

    const { highwayCarrier } = data || {}
    const { contacts } = highwayCarrier || {}
    const dispatchers =
      contacts?.filter(contact => contact.isType === 'dispatch') || ([] as IHighwayContact[])
    const uniqueDispatchers = dispatchers.reduce(
      removeDuplicateDispatchers,
      [] as IHighwayContact[]
    )

    const Title = () => <Typography variant='subtitle1'>Contacts</Typography>

    return (
      <CollapsibleSection Title={Title}>
        {error && <InlineMessage message={error.message} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
        {uniqueDispatchers?.map(({ emailAddress, id, isType, name, phone }, i) => (
          <Box
            key={id}
            display='grid'
            gridTemplateColumns='1fr 1fr'
            gap='12px'
            borderBottom={
              i === uniqueDispatchers.length - 1 ? 'none' : `1px solid ${brandColors.coolGray2}`
            }
            mb='8px'
            pb='8px'>
            <ValueField title='Carrier Contact Name' value={name} loading={loading} />
            <ValueField title='Carrier Contact Email' value={emailAddress} loading={loading} />
            <ValueField
              title='Contact Type'
              value={isType && capitalize(isType)}
              loading={loading}
            />
            <ValueField title='Carrier Contact Phone' value={phone} loading={loading} />
          </Box>
        ))}
      </CollapsibleSection>
    )
  }
)
